/* eslint-disable */

import axios from "axios";
import { make } from "vuex-pathify";

const url = require("../../client_config/config").url;

const state = {
  messages: [],
};

const getters = {};

const actions = {
  async fetchMessages({ commit }) {
    try {
      const response = await axios.get(`${url}/chatx/`);
      commit("SET_MESSAGES", response.data.chats);
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  },

  async sendMessage({ commit }, data) {
    try {
      const response = await axios.post(`${url}/chatx/`, data);
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  },

  async likeChatMessage({ commit }, data) {
    try {
      const response = await axios.put(
        `${url}/chatx/${data[0].chatID}/${data[0].userID}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  chatMessageLikes({ commit }, data) {
    commit("SET_CHAT_MESSAGE_LIKES", data);
  }
};

const mutations = {
  ...make.mutations(state),
  SET_MESSAGES(state, data) {
    data.map((chat) => {
      state.messages.push({
        ...Object.assign({}, chat),
        me: chat.User?._id === localStorage.getItem("userID"),
      });
    });
  },
  SET_CHAT_MESSAGE_LIKES(state, data) {
    state.messages = state.messages.map(message => {
      if (message.Likes) {
        if (data[0].chatID === message._id) {
          message.Likes.forEach(like => {
            if (data[0].isLike[0].userID === like.userID) {
              like.isLike = data[0].isLike[0].isLike;
            }
          });
        }
      }

      return message;
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
